import { H1, IconButton } from "@datapay-by-datacom/design-system";
import { useNavigate } from "react-router-dom";
import { IoChevronBack } from "react-icons/io5";
import s from "./UnauthorizedMessage.module.css";

interface UnauthorizedMessageProps {
  backLabel?: string;
}

export function UnauthorizedMessage({
  backLabel = "Back",
}: UnauthorizedMessageProps) {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className={s.container}>
      <div className={s.backButton}>
        <IconButton onPress={handleGoBack}>
          <IoChevronBack size={20} />
        </IconButton>
        <span>{backLabel}</span>
      </div>
      <H1>Unauthorized</H1>
      <p className={s.message}>
        You do not have permission to access this content.
      </p>
    </div>
  );
}
